import React, { memo } from 'react'
import { Text } from 'common-components'
import * as Styled from './styled'

interface IUnlimitedBadgeProps {
  onClick: () => void
}

const UnlimitedBadge: React.FC<IUnlimitedBadgeProps> = ({ onClick }) => {
  return (
    <Styled.UnlimitedBadge onClick={onClick}>
      <Text type="h6" color="white" fontWeight="700" letterSpacing="0.4px">
        GET UNLIMITED
      </Text>
    </Styled.UnlimitedBadge>
  )
}

export default memo(UnlimitedBadge)
